import { takeOnce, withStorage } from './storage';
import type { PromptId } from './prompts';

// ==============================|| PROMPTS — ONE PER VISIT ||============================== //
// A visit is this tab's session: page changes, reloads and layout remounts stay inside it. Whichever
// interrupting prompt claims the slot first is the only one that visit.

const slotKey = (userId: string) => `tc-prompt-slot:${userId}`;

export const isVisitSlotFree = (userId: string, storage?: Storage): boolean =>
  withStorage(false, () => !(storage ?? sessionStorage).getItem(slotKey(userId)));

/** Takes this visit's slot for a prompt about to open; false when another prompt already has it. */
export const claimVisitSlot = (userId: string, prompt: PromptId, storage?: Storage): boolean => takeOnce(slotKey(userId), prompt, storage);
